export default __webpack_public_path__ + "static/media/stratesys.944b7fd5.svg";